import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { PlayerNews } from './news';
import { PlayerOverview } from './overview';
import { PagePlayerWrap } from '../components/page';
import { useAsyncFn } from '@zmedia/bm-soccer-ui/hooks';
import { TAB_IDS } from '../../shared';
import { ObjectUtils } from '@zmedia/bm-soccer-ui/utils';
import PageService from '@zmedia/bm-soccer-ui/service/PageService';
import { IContentItemClass } from '@zmedia/bm-soccer-ui/interface';

export function PlayerPageView({
    content,
    otherData = {},
    listProps,
}: {
    content: any;
    otherData: any;
    listProps: any;
}) {
    const router = useRouter();
    let data = content;
    const { id } = router.query;

    if (ObjectUtils.isEmpty(data)) {
        const [state, callback] = useAsyncFn(PageService.getPlayerDetail);
        useEffect(() => {
            callback(id);
        }, [id]);
        data = state.value?.data || {};
    }

    if (ObjectUtils.isEmpty(data)) {
        return null;
    }

    const renderTabs = () => {
        switch (data.activeTab) {
            case TAB_IDS.NEWS:
                return (
                    <PlayerNews
                        {...data}
                        {...otherData}
                        listProps={Object.assign({}, listProps, {
                            ContentItemClass: {
                                CardClass: 'max-md:flex-row',
                                CardContentClass: "max-md:ml-[15px] md:mt-[7px]",
                                CardImageClass: 'md:w-full',
                            } as IContentItemClass,
                        })}
                    />
                );
            default:
                return <PlayerOverview {...data} />;
        }
    };

    return <PagePlayerWrap {...data}>{renderTabs()}</PagePlayerWrap>;
}

export default PlayerPageView;
